import { EuiLink } from "@inscopix/ideas-eui";
import { Tour } from "../TourProvider.types";

export const TourDataTableUploadFiles: Tour = {
  name: "Uploading data",
  pages: ["projectDataTable"],
  conditions: { isProjectEditor: true },
  description: "Learn how to upload files from your computer to IDEAS",
  steps: [
    {
      anchorId: "file-browser-bottom-bar-button",
      title: "File Browser",
      content: "First, click on 'Files' to open your Project file browser",
    },
    {
      anchorId: "file-browser-upload",
      title: "Upload Files to File Browser",
      content: `You can either click in the file browser to search and select which files to upload, or simply drag them into the file browser box`,
    },
    {
      anchorId: "table-flex-item",
      title: "Upload Files to Table",
      content:
        "Alternatively, you can upload files directly to a data table cell.",
      props: {
        repositionOnScroll: true,
        attachToAnchor: false,
        hasArrow: false,
        decoration: "none",
      },
    },
    {
      anchorId: "header-upload-button",
      title: "File uploading and processing",
      content: (
        <span>
          While files are uploading, do not close the IDEAS tab (this will
          disrupt the upload). After a file is finished uploading, IDEAS will
          process the file to create a visual preview and extract metadata (if
          it’s a known file type). Learn more{" "}
          <EuiLink
            href="https://inscopix.github.io/ideas-docs/upload-data.html"
            target="_blank"
          >
            here
          </EuiLink>
          .
        </span>
      ),
    },
  ],
};
